import { Syringe } from 'mana-syringe'; // 1 of 1 in each Canvas

export var ContextService = Syringe.defineToken('ContextService', {
  multiple: false
});